module.exports = __webpack_public_path__ + "images/witcher_rgba(0,0,0,0.7).jpg?v=60b530f12ebdcfea92fcc757ea805c91";